<template>
  <div class="form__order-info">
    <slot></slot>
    <hr />
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.form__order-info {
  margin: 20px 0;
}
</style>
